import apiClient from '../index';

export const getChildren = async () => {
  try {
    const response = await apiClient.get('/api/child/');
    console.log('Raw getChildren response:', response);
    
    // Extract data properly from { message: 'Successful', data: [...children] } structure
    const studentsData = response.data?.data;
    
    if (!studentsData) {
      console.error('Students data not found in response:', response.data);
      return [];
    }
    
    if (Array.isArray(studentsData)) {
      return studentsData.map(child => ({
        id: child.childId,
        childId: child.childId,
        firstName: child.firstName,
        lastName: child.lastName,
        name: `${child.firstName || ''} ${child.lastName || ''}`.trim() || 'Unnamed Student',
        className: child.class || 'Not Assigned',
        class: child.class || 'Not Assigned',
        attendance: child.attendance || [],
        performance: child.performance || 0,
        teacher: child.teacher || { name: 'Not Assigned' },
        isActive: child.status === 'active',
        status: child.status,
        photoUrl: child.photoUrl || "/placeholder.svg",
        avatar: child.photoUrl || "/placeholder.svg",
        parent: child.parent,
        organizationId: child.organizationId
      }));
    }
    return [];
  } catch (error) {
    console.error('Error fetching children:', error);
    throw new Error('Failed to fetch students');
  }
};

export const getChildById = async (id) => {
  // Validate ID parameter before making the API call
  if (!id) {
    throw new Error('Child ID is required');
  }
  
  try {
    // Make the API call
    const response = await apiClient.get(`/api/child/${id}`);
    console.log('Raw API Response:', response);
    
    // Extract the child data from the response
    // The API returns { message: 'Successful', data: child }
    const childData = response.data?.data;
    
    if (!childData) {
      console.error('Child data not found in response:', response.data);
      throw new Error('Child data not found in API response');
    }
    
    // Return the extracted data
    return childData;
  } catch (error) {
    console.error(`Error fetching child with id ${id}:`, error);
    throw new Error(`Failed to fetch student with ID: ${id}`);
  }
};

export const createChild = async (childData) => {
  try {
    const response = await apiClient.post('/api/child', childData);
    return response.data;
  } catch (error) {
    console.error('Error creating child: ', error);
    throw error;
  }
};

export const updateChild = async (id, childData) => {
  try {
    const response = await apiClient.put(`/api/child/${id}`, childData);
    return response.data;
  } catch (error) {
    console.error(`Error updating child with id ${id}: `, error);
    throw error;
  }
};

export const deleteChild = async (id) => {
  try {
    const response = await apiClient.delete(`/api/child/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting child with id ${id}: `, error);
    throw error;
  }
};
